// convert timestamp number to a date format to be used by Form.Control type "date"
// returns a string
const timestampToHTMLDateInput = (timestampNumber) => {
    if(typeof timestampNumber !== 'number'){
        return "";
    }
    let local = new Date(timestampNumber).toLocaleDateString('en-US');
    let localArray = [];
    if(local.includes('-')){
        localArray = local.split('-');
    }else if(local.includes('/')){
        localArray = local.split('/');
    }else{
        return "";
    }
    // return `${localArray[2]}-${localArray[0] < 10 ? "0": ""}${localArray[0]}-${localArray[1] < 10 ? "0" : ""}${localArray[1]}`;
    return `${localArray[2]}-${localArray[0].padStart(2,"0")}-${localArray[1].padStart(2,"0")}`;
};

// convert Form.Control type date string (2022-04-03) to timestamp (1649039173000) (account for time zone offset done internally by javascript)
// returns a number
const HTMLDateInputToTimestamp = (dateString) =>{
    if(typeof dateString !== 'string' || dateString === ''){
        return "";
    }
    let timezoneOffset = new Date(dateString).getTimezoneOffset() * 60 * 1000;
    return new Date(dateString).getTime()+timezoneOffset;
};

const currentTimeStamp = () => {
    return Date.now();
};

const calcHourTimeStampDiff = (startTimestamp, endTimestamp) =>{
  return (parseInt(endTimestamp) - parseInt(startTimestamp)) / (1000 * 60 * 60);
}

export { timestampToHTMLDateInput, HTMLDateInputToTimestamp, currentTimeStamp, calcHourTimeStampDiff };